let instance = null;

export default class Singleton {  
  constructor() {
    if (!instance) {
      instance = this;
    }
    this.oAuthToken = null;
    this.company_id = null;
    this.context= null;
    return instance;
  }
}
